import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavController, NavParams, LoadingController } from "ionic-angular";

import { NotificationsProvider } from "./../../providers/notifications/notifications";
import { AuthProvider } from "./../../providers/auth/auth";

import { JobPage } from "./../job/job";
import { TrainingCardPage } from "./../training-card/training-card";

import { INotification } from "./../../interfaces/notifications";

@Component({
  selector: "page-notifications",
  templateUrl: "notifications.html",
})
export class NotificationsPage implements OnInit, OnDestroy {
  title = "Notifications";

  fbUser: any;

  notificationsSubscription: any;
  notificationDataLoaded = false;
  notifications: INotification[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private notificationsProvider: NotificationsProvider,
    private authProvider: AuthProvider
  ) {}

  ngOnInit() {
    this.authProvider
      .getFbUser()
      .then((fbUser) => {
        if (fbUser) {
          this.fbUser = fbUser;
          this.loadNotifications(fbUser.uid);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  ngOnDestroy() {
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }
  }

  loadNotifications(uid: string) {
    let loader = this.loadingCtrl.create({
      content: "Loading notifications...",
    });
    loader.present();

    this.notificationsSubscription = this.notificationsProvider
      .getNotifications(uid)
      .subscribe(
        (data) => {
          console.log(data);
          this.notifications = data.reverse();
          this.notificationDataLoaded = true;

          setTimeout(() => {
            loader.dismiss();
          }, 100);

          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  openPage(notification: INotification) {
    console.log(notification);

    if (notification.status === 0) {
      this.notificationsProvider.readNotification(
        this.fbUser.uid,
        notification.id,
        1
      );
    }

    let component;

    switch (notification.component) {
      case "job":
        component = JobPage;
        break;
      case "training-card":
        component = TrainingCardPage;
        break;
      default:
        break;
    }

    if (notification.item) {
      this.navCtrl.push(component, { item: notification.item });
    } else {
      this.navCtrl.push(component);
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad NotificationsPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts